/**
 * What a flight change does to the trip's travel insurance, in one line
 * (_shared/faye-reprice.js re-prices it for the new flight). Null when the
 * trip has none or nothing about it changes.
 */
export function insuranceRepriceNote(insurance, fmt) {
  if (!insurance?.repriced) return null;
  const becomes = insurance.label_changed ? ` It becomes ${insurance.label} for this trip.` : '';
  if (insurance.charge_today_cents > 0) {
    return `Includes $${fmt(insurance.charge_today_cents)} for your travel insurance, now $${fmt(insurance.new_premium_cents)} for the new flight.${becomes}`;
  }
  if (insurance.owed_back_cents > 0) {
    return `Your travel insurance drops to $${fmt(insurance.new_premium_cents)} for the new flight. We'll refund the $${fmt(insurance.owed_back_cents)} difference to your card.${becomes}`;
  }
  return insurance.label_changed ? `Your travel insurance becomes ${insurance.label} for this trip, at the same price.` : null;
}
